module.exports = __webpack_public_path__ + "assets/1e998a9668f564f7b81b9026e60e48de.mp3";